export default __webpack_public_path__ + "static/media/logo.26fac790.png";